import React from "react";
import ToolShell from "@/components/ToolShell";

export function PrivacyPage() {
  return (
    <ToolShell tool="Legal" title="Privacy" hidePrivacyBadge wide>
      <article className="space-y-5 text-ink-muted leading-relaxed">
        <p>
          <strong className="text-ink">TL;DR:</strong> No login. No financial data stored. No ads. No selling data.
          No third-party tracking scripts. The only email we ever collect is if you opt in to deadline reminders,
          and unsubscribing is one click.
        </p>

        <h2 className="font-heading text-2xl text-ink mt-8">What we collect</h2>
        <ul className="list-disc pl-5 space-y-1">
          <li>Anonymous usage analytics (tool opened, buttons clicked), hashed IDs only, no PII, no financial data.</li>
          <li>Your email address, only if you opt in to deadline reminders.</li>
        </ul>

        <h2 className="font-heading text-2xl text-ink mt-8">What we do NOT collect</h2>
        <ul className="list-disc pl-5 space-y-1">
          <li>Your SSN, date of birth, or legal name.</li>
          <li>Your income, assets, or tax data. The SAI estimator, loan calculator, and school comparer all run in your browser, your numbers never leave your device.</li>
          <li>Your FAFSA answers. We don't store them.</li>
          <li>Your chat history. Conversations disappear when you close the tab.</li>
        </ul>

        <h2 className="font-heading text-2xl text-ink mt-8">Third parties</h2>
        <p>
          AI responses come from Anthropic's Claude. Prompts contain no PII, only the text you type.
          Emails are sent via Resend. PostHog provides anonymous product analytics with IP suppressed.
        </p>

        <h2 className="font-heading text-2xl text-ink mt-8">Your data, your control</h2>
        <p>
          If you subscribed to emails, click Unsubscribe in any email and your record is deleted immediately.
          If you want to ask a question, write to{" "}
          <a href="mailto:privacy@aidwaive.ai" className="link">privacy@aidwaive.ai</a>.
        </p>
      </article>
    </ToolShell>
  );
}

export function TermsPage() {
  return (
    <ToolShell tool="Legal" title="Terms" hidePrivacyBadge wide>
      <article className="space-y-5 text-ink-muted leading-relaxed">
        <p>
          AidWaive is a free informational tool. We are not affiliated with the U.S. Department of Education.
          We do not submit your FAFSA, only studentaid.gov can do that.
        </p>
        <p>
          All optimization guidance, SAI estimates, loan math, and school comparisons are for educational
          purposes only and do not constitute tax, legal, or financial advice. Consult a financial aid
          professional before making financial decisions.
        </p>
        <p>
          AidWaive is free today and committed to staying free for students and families. If that ever changes,
          we'll announce it here with at least 60 days notice. No credit card will ever be collected on this
          site without your explicit action.
        </p>
        <p>Contact: <a href="mailto:hello@aidwaive.ai" className="link">hello@aidwaive.ai</a>.</p>
      </article>
    </ToolShell>
  );
}
